const KIOSK_SUBDOMAIN = process.env.REACT_APP_KIOSK_SUBDOMAIN?.trim().toLowerCase() || 'orbiter';

export const isKioskHostname = (hostname: string) => {
    const h = hostname.toLowerCase();

    return h.startsWith(`${KIOSK_SUBDOMAIN}.`);
};